import { RemoveScroll } from "react-remove-scroll";
import ReactDom from "react-dom";
import { useTranslation } from "react-i18next";

const ConfirmModal = ({ open, handleClose, submit, loading }) => {
    const { t } = useTranslation(0);
    if (!open) return null;

    return ReactDom.createPortal(
        <div className='fixed top-0 left-0 right-0 h-screen bg-black/40 overflow-clip'>
            <RemoveScroll className='flex justify-center h-full flex-col p-10 bg-transparent'>
                <div
                    className='h-full w-full z-10 absolute bg-transparent'
                    onClick={loading ? null : handleClose}
                ></div>
                <div className='bg-white z-50 w-fit px-7 pt-8 pb-3 mx-auto gap-3 flex flex-col rounded-md'>
                    <p className="text-center max-w-[450px]">
                        {t("submit-message")}
                    </p>
                    <div className='flex md:justify-end justify-center gap-3 text-white'>
                        {loading ? null : (
                            <button
                                className='px-5 py-1 rounded-md bg-red-700'
                                type='button'
                                onClick={handleClose}
                                disabled={loading}
                            >
                                {t("Cancel")}
                            </button>
                        )}
                        <button
                            className='px-5 py-1 rounded-md bg-MetallicBlue'
                            type='submit'
                            onClick={submit}
                            disabled={loading}
                        >
                            {loading
                                ? t("update-button-submitting")
                                : t("update-button-submit")}
                        </button>
                    </div>
                </div>
            </RemoveScroll>
        </div>,
        document.getElementById("portal")
    );
};

export default ConfirmModal;
